export default {
  article: {
    image: {
      maxSize: 1024 * 1024,
      uploadSize: 10 * 1024 * 1024
    },
    attachment: {
      file: {
        maxSize: 10,
        format: [],
        name: '附件'
      },
      video: {
        maxSize: 50,
        format: ['mp4', 'avi'],
        name: '视频'
      }
    }
  },
  category_types: [
    // {value: 'picture', name: '照片型'},
    // {value: 'album', name: '相册型'},
    {
      value: 'page',
      name: '页面型'
    },
    {
      value: 'catalogue',
      name: '目录型'
    },
    {
      value: 'list',
      name: '内容列表'
    },
    // {value: 'quote', name: '引用型'},
    {
      value: 'link',
      name: '链接型'
    },
    {
      value: 'video',
      name: '视频型'
    }
  ],
  templates: {
    list: [{
        value: 'with-thumbnail',
        name: '带略缩图型列表'
      },
      {
        value: 'text-list',
        name: '文本型列表'
      }
    ],
    article: [{
        value: 'mordern',
        name: '现代型模版'
      },
      {
        value: 'classic',
        name: '古典型模版'
      }
    ],
    video: [{
      value: 'basic',
      name: '基本型模版'
    }],
    page: [{
        value: 'block',
        name: '区块显示'
      },
      {
        value: 'basic',
        name: '基本型模版'
      }
    ],
    portfolio: [{
      value: 'basic',
      name: '基本型模版'
    }],
    picture: [{
      value: 'basic',
      name: '基本型模版'
    }]
  }
}


// WEBPACK FOOTER //
// ./src/store/config/cms.js